interface SaveDepartmentGrantsRequestPayload {
  catalog_permission: {
    view_type: 'department'
    data: Record<string, number[]>
  }
}

export const mapSaveDepartmentGrantsPayload = (
  secondaryCategoryId: number,
  userIds: number[]
): SaveDepartmentGrantsRequestPayload => ({
  catalog_permission: {
    view_type: 'department',
    data: {
      [secondaryCategoryId]: userIds,
    },
  },
})
